import React from 'react'

import clsx from 'clsx'

import EmptyState from 'components/EmptyState'
import Icon from 'components/Icon'
import IconText from 'components/IconText'
import Rating from 'components/Rating'
import Tooltip from 'components/Tooltip'
import { useAppContext } from 'context/AppContext'
import { useEventContext } from 'context/EventContext'
import { formatRatingAverage, kFormatter } from 'helpers/formatters'
import { getengagementDestination } from 'helpers/reviews'
import { isListingDetail } from 'helpers/routes'

import starSVG from 'assets/empty-state-star.svg'

import styles from './Display.module.scss'

/** @type {import("./types").default} */
const Display = ({
  className,
  href,
  hideReviewsNumber = false,
  reviewsNumber,
  rating,
  subscript = '/5',
  variant = 'large',
}) => {
  const { addEvent, sendEvent } = useEventContext()
  const { route } = useAppContext()

  return (
    <div className={clsx('Display', styles.root, styles[variant], className)}>
      {reviewsNumber > 0 && rating > 0 ? (
        <>
          <Rating.Display display={formatRatingAverage(rating)} subscript={subscript} variant={variant} />
          {!hideReviewsNumber && (
            <div className={styles.iconTextWithTooltip}>
              <IconText
                icon={['far', 'user']}
                text={kFormatter(reviewsNumber)}
                variant={variant}
                {...addEvent({
                  engagementDestination: getengagementDestination(href, { isListingDetail: isListingDetail(route) }),
                  engagementDetails: 'text-link_number-reviews',
                  name: 'engagement_product_click',
                })}
              />
              <Tooltip
                enterTouchDelay={50}
                placement="top"
                title="Based on GetApp's extensive, proprietary database of in-depth, verified user reviews."
                sendOnEnterEvents={() => {
                  sendEvent({
                    name: 'engagement_hover',
                    engagementDestination: 'show_reviews-methodology',
                    engagementDetails: 'hover_rating',
                    engagementComponent: 'product_reviews',
                  })
                }}
              >
                <div className={styles.infoCircleContainer}>
                  <Icon prefix="far" icon="circle-info" size="16" />
                </div>
              </Tooltip>
            </div>
          )}
        </>
      ) : (
        <EmptyState img={starSVG.src} variant={variant} text="No reviews" />
      )}
    </div>
  )
}

export default Display
